/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Challenge_Phase_1_Description_Ver2Inputs */

const en_starter_challenge_phase_1_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_1_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get to know your forest and claim lucky rewards!`)
};

const ar_starter_challenge_phase_1_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_1_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعرّف على غابتك واحصل على مكافآت الحظ!`)
};

const de_starter_challenge_phase_1_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_1_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lernen Sie Ihren Wald kennen und sichern Sie sich Glücksbelohnungen!`)
};

const es_starter_challenge_phase_1_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_1_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Descubre tu bosque y consigue recompensas de la suerte!`)
};

const fr_starter_challenge_phase_1_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_1_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découvrez votre forêt et gagnez des récompenses chanceuses !`)
};

const it_starter_challenge_phase_1_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_1_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri la tua foresta e ottieni premi fortunati!`)
};

const ja_starter_challenge_phase_1_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_1_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分の森について知り、ラッキーな報酬をゲットしましょう！`)
};

const ko_starter_challenge_phase_1_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_1_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나만의 숲을 알아보고 행운의 보상을 받아보세요!`)
};

const pt_br_starter_challenge_phase_1_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_1_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conheça sua floresta e ganhe recompensas da sorte!`)
};

const ru_starter_challenge_phase_1_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_1_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изучите свой лес и получите счастливые награды!`)
};

const th_starter_challenge_phase_1_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_1_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทำความรู้จักกับป่าของคุณ และรับรางวัลนำโชค!`)
};

const tr_starter_challenge_phase_1_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_1_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ormanını tanı ve şanslı ödülleri kazan!`)
};

const zh_cn_starter_challenge_phase_1_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_1_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`熟悉你的森林并解锁幸运礼物！`)
};

const zh_tw_starter_challenge_phase_1_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_1_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`熟悉你的森林並解鎖幸運禮物！`)
};

/**
* | output |
* | --- |
* | "Get to know your forest and claim lucky rewards!" |
*
* @param {Starter_Challenge_Phase_1_Description_Ver2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_challenge_phase_1_description_ver2 = /** @type {((inputs?: Starter_Challenge_Phase_1_Description_Ver2Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Challenge_Phase_1_Description_Ver2Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_challenge_phase_1_description_ver2(inputs)
	if (locale === "ar") return ar_starter_challenge_phase_1_description_ver2(inputs)
	if (locale === "de") return de_starter_challenge_phase_1_description_ver2(inputs)
	if (locale === "es") return es_starter_challenge_phase_1_description_ver2(inputs)
	if (locale === "fr") return fr_starter_challenge_phase_1_description_ver2(inputs)
	if (locale === "it") return it_starter_challenge_phase_1_description_ver2(inputs)
	if (locale === "ja") return ja_starter_challenge_phase_1_description_ver2(inputs)
	if (locale === "ko") return ko_starter_challenge_phase_1_description_ver2(inputs)
	if (locale === "pt_br") return pt_br_starter_challenge_phase_1_description_ver2(inputs)
	if (locale === "ru") return ru_starter_challenge_phase_1_description_ver2(inputs)
	if (locale === "th") return th_starter_challenge_phase_1_description_ver2(inputs)
	if (locale === "tr") return tr_starter_challenge_phase_1_description_ver2(inputs)
	if (locale === "zh_cn") return zh_cn_starter_challenge_phase_1_description_ver2(inputs)
	return zh_tw_starter_challenge_phase_1_description_ver2(inputs)
});